/**
 * Determines if the browser is an outdated version of Internet Explore
 */
export function browserIsOutdated() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");

  // eslint-disable-next-line
  const IE = msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);

  return IE;
}
